'use strict';
import angular from 'angular';
import ProfessionalInfoController from './professional-info.controller';
import GeneralInfoService from '../general-info/general-info.service';
import ProfessionalInfoService from './professional-info.service';
export default angular.module('directives.professionalInfoForm', [])
    .controller('ProfessionalInfoController', ProfessionalInfoController)
    .service('GeneralInfoService', GeneralInfoService)
    .service('ProfessionalInfoService', ProfessionalInfoService)
    .component('professionalInfoForm', {
    template: require('./professional-info.html'),
    controller: ProfessionalInfoController,
    controllerAs: 'pi',
    bindings: {
        pinfo: '=',
        onUpdate: '&',
        mode: '<',
        changeAccountInfo: '<',
        credentials: '=',
        rxConfig: '=',
        createForm: '<',
        updateForm: '<'
    }
})
    .name;
//# sourceMappingURL=index.js.map